// Import helpers
import { createLinkParams } from 'helpers';
import { getTitleImage } from 'components/views/vod/helpers/getTitleImage';
import { sendGTMEvent } from 'helpers/tracking';
import { useElementDimensions } from 'components/utilities';

// Import helpers
import {
	GTM_TRACKING_EVENTS,
	VIDEO_GTM_ACTION,
	FILM_GTM_SEGMENTATION
} from 'helpers/tracking';

const { INTERACT_WITH_FILM } = GTM_TRACKING_EVENTS;

const useElementInfo = ({
	images,
	rating,
	year,
	duration,
	genres,
	subtype,
	country,
	previews,
	title,
	uuid
}) => {
	const to = createLinkParams({ id: uuid, type: subtype, title });
	const titleImage = getTitleImage(images);
	const {
		elementRef,
		getResizeUrl,
		isLoaded,
		width,
		height
	} = useElementDimensions();

	const image = isLoaded ? `${titleImage}${getResizeUrl()}` : null;

	const videoId = previews?.preview?.[0]?.videoAssetId;

	const handleGTMEvent = ({ linkRedirect, pathname, label }) => {
		const customEventData = {
			segmentation: FILM_GTM_SEGMENTATION,
			action: VIDEO_GTM_ACTION,
			page_url: pathname,
			genres,
			item_name: title,
			item_variant: rating,
			release_year: year,
			country,
			runtime: duration,
			label
		};

		if (linkRedirect) customEventData.url = linkRedirect?.pathname;

		sendGTMEvent({
			event: INTERACT_WITH_FILM,
			customEventData
		});
	};

	return {
		elementRef,
		handleGTMEvent,
		to,
		titleImage: image,
		width,
		height,
		videoId
	};
};

export default useElementInfo;
